export default {
  nav: {
    firstStep: "il primo passo",
    navigate: "come spostarsi",
    whyUs: "perché veki?",
    nice: "che bella",
    shop: "shop",
    shopAll: "qualunque cosa",
    shopContainers: "contenitori",
    shopLarvals: "larvale",
    shopOrganizers: "organizzatori",
    shopBoxes: "scatole",
    shopCategoryKits: "kit",
    shopCategoryLabels: "etichette",
    shopCategoryVouchers: "buoni",
    organizeDrawer: "organizzare cassetto",
    genDimensions: "invia dimensioni",
    genDesign: "progettazione",
    materials: "tipi di finiture",
    blog: "inspirazione",
    myAccount: "mio conto",
    contact: "contatti"
  },
  user: {
    register: {
      email_blank: "L'email dell'utente non può essere vuota.",
      password_blank: "La password dell'utente non può essere vuota.",
      success: "Registrazione effettuata con successo.",
      user_exists: "L'utente con questo nome / email esiste già."
    },
    login: {
      username_blank: "Il nome utente non può essere vuoto.",
      password_blank: "La password non può essere vuota.",
      invalid_username: "Questo nome utente non è corretto.",
      incorrect_password: "Questa password per questo utente non è corretta.",
      unexpected_error: "Si è verificato un problema imprevisto.",
      success: "Registrato correttamente."
    },
    unexpected_error: "Si è verificato un problema imprevisto.",
    forgotten_pass: "Password dimenticata?"
  },
  contact: {
    contact_subject_blank: "L'oggetto del messaggio non può essere vuoto.",
    contact_name_blank: "Il nome del mittente non può essere vuoto.",
    contact_surname_blank: "Il cognome del mittente non può essere vuoto.",
    contact_email_blank: "L'e-mail del mittente non può essere vuota.",
    contact_message_blank: "Il messaggio non può essere vuoto.",
    form_success: "Messaggio inviato con successo.",
    form_failed:
      "Si è verificato un errore durante il tentativo di inviare il messaggio.",
    expired_captcha: "Captcha scaduto."
  },
  cart: {
    update: {
      success: "Aggiornato con successo.",
      errror: "Qualcosa è andato storto durante l'aggiornamento."
    },
    shipping: {
      not_enough_data:
        "Non sono stati dati abbastanza dati per calcolare il costo di spedizione."
    },
    coupon: {
      apply: {
        cart_empty: "Il carrello non può essere vuoto.",
        code_blank: "Il codice del buono non può essere vuoto.",
        code_invalid: "Il codice voucher fornito non è valido.",
        code_used_up: "Il voucher fornito ha superato il limite di utilizzo.",
        code_expired: "Il voucher è scaduto.",
        success: "Il buono è stato aggiunto con successo.",
        code_exists: "Il voucher fornito è già stato aggiunto.",
        error: "Si è verificato un problema imprevisto."
      },
      remove: {
        code_blank: "Il codice voucher fornito non esiste.",
        success: "Il buono è stato rimosso con successo.",
        code_not_removed: "Il buono non è stato rimosso.",
        error: "Si è verificato un problema imprevisto."
      }
    }
  },
  checkout: {
    click_here: "Clicca qui",
    message: " per accedere / registrarsi."
  },
  country: {
    PL: 'Polonia',
    KZ: 'Kazakistan',
    AL: 'Albania',
    AD: 'Andorra',
    AT: 'Austria',
    BE: 'Bielgia',
    BY: 'Bielorussia',
    BA: 'Bosnia ed Erzegovina',
    BG: 'Bulgaria',
    BG_BG_21: 'Smolyan',
    HR: 'Croazia',
    ME: 'Montenegro',
    CZ: 'Repubblica Ceca',
    DK: 'Danimarca',
    EE: 'Estonia',
    FI: 'Finlandia',
    FR: 'Francia',
    GR: 'Grecia',
    ES: 'Spagna',
    NL: 'Paesi Bassi',
    IE: 'Irlanda',
    IS: 'Islanda',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Lussemburgo',
    MK: 'Macedonia',
    MT: 'Malta',
    MC: 'Monaco',
    DE: 'Germania',
    NO: 'Norvegia',
    PT: 'Portogallo',
    RU: 'Russia',
    RO: 'Romania',
    SM: 'San Marino',
    RS: 'Serbia',
    CH: 'Svizzera',
    SE: 'Svezia',
    SK: 'Slovacchia',
    SI: 'Slovenia',
    TR: 'Turchia',
    VA: 'Vaticano',
    GB: 'Gran Bretagna',
    HU: 'Ungheria',
    IT: 'Italia',
    LV: 'Lettonia',
    CA_NS: 'Nuova Scozia'
  }
};